import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
import { ChevronDown, Terminal } from 'lucide-react';
const faqs = [{
  q: '¿Y si soy demasiado tímido para que esto funcione?',
  a: 'Este método fue creado precisamente para los casos más extremos. Empezamos con retos de 1 segundo que no requieren hablar con nadie. Tú controlas el ritmo.'
}, {
  q: '¿Tengo que grabarme o hacer cosas ridículas en público?',
  a: "No. Los 'Hacks' son discretos. Nadie notará que estás aplicando el protocolo, solo notarán que te ves más seguro."
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso instantáneo por email. Puedes leerlo en tu celular o tablet en cualquier lugar.'
}, {
  q: '¿Funciona para mayores de 25?',
  a: 'Sí, aunque el lenguaje es joven, la neurociencia de la micro-exposición funciona para todos los cerebros humanos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionWrapper className="bg-cyber-dark/50 border-y border-gray-800" data-id="element-181">
      <div className="text-center mb-12" data-id="element-182">
        <h2 className="text-3xl md:text-4xl text-white mb-4 font-mono flex items-center justify-center gap-3" data-id="element-183">
          <Terminal className="text-cyber-neon" data-id="element-184" />
          FAQ{' '}
          <span className="text-gray-500 text-xl" data-id="element-185">
            {'//'} Manejo de Objeciones
          </span>
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-186">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={index} className={`border rounded-lg overflow-hidden transition-colors duration-300 ${isOpen ? 'border-cyber-neon bg-cyber-neon/5' : 'border-gray-800 bg-cyber-black hover:border-gray-600'}`} data-id="element-187">
              <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-188">
                <span className={`font-mono font-bold ${isOpen ? 'text-cyber-neon' : 'text-gray-300'}`} data-id="element-189">
                  <span className="text-gray-500 mr-2" data-id="element-190">?</span> {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180 text-cyber-neon' : 'text-gray-500'}`} data-id="element-191" />
              </button>

              <AnimatePresence data-id="element-192">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-193">
                    <div className="px-6 pb-4 pt-0 text-gray-400 border-t border-cyber-neon/10 mt-2 pt-4 flex gap-3" data-id="element-194">
                      <span className="text-cyber-neon font-mono font-bold" data-id="element-195">
                        {'>'}
                      </span>
                      <p data-id="element-196">{faq.a}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </SectionWrapper>;
}